import React from "react";
import { useParams } from "react-router-dom";
import { Typography, Box, Stack, Divider, useMediaQuery } from "@mui/material";
import BrochureImage from "../../components/UI/Brochure/BrochureAtoms/BrochureImage";
import inno from "../../assets/innoAlRe/1.JPG";
import inno2 from "../../assets/innoAlRe/stdip.jpg";

import osteria from "../../assets/osteria/1.JPG";
import matri from "../../assets/matrimonio/1.JPG";
import molinara from "../../assets/molinara/room1.JPG";
import barbiere from "../../assets/barbiere/1.JPG";
import CarouselInfo from "../../components/UI/Carousel/CarouselInfo";
import CarouselRooms from "../../components/UI/Carousel/CarouselRooms";
import Footer from "../Footer/Footer";
import SocialIcons from "../../components/UI/IconsComponents/SocialIcons";
import SectionTwoStableMob from "../SectionTwo/Mobile/SectionTwoStableMobile";
import DividerContainer from "../../components/UI/Divider/DividerContainer";
import RoomDetails from "./RoomDetails";
import RoomIcon from "@mui/icons-material/Bed"; // Icona della camera da letto
import { t } from "i18next";
import CustomTypography from "../../components/UI/Typography/CustomTypograhy";
import FooterGallery from "../Footer/FooterGallery";
import FollowBox from "../../components/FollowUs/FollowUs";
import RoomTab from "./RoomTab";
import { ParallaxBanner } from "react-scroll-parallax";

const RoomSingle = () => {
  const isTablet = useMediaQuery("(min-width: 768px)");
  const isMobile = useMediaQuery("(max-width: 768px)");
  const roomsData = [
    {
      roomCode: "room1",
      id: 1,
      label: "INNO AL RE",
      link: "/rooms/1",
      src: isMobile ? inno : inno2,
    },
    {
      roomCode: "room2",
      label: "IL BARBIERE DI SIVIGLIA",
      id: 2,
      link: "/rooms/2",
      src: barbiere,
    },
    {
      roomCode: "room3",
      id: 3,
      label: "L’OSTERIA DI MARECHIARO",
      link: "/rooms/3",
      src: osteria,
    },
    {
      roomCode: "room4",
      id: 4,
      label: "LA MOLINARA",
      link: "/rooms/4",
      src: molinara,
    },
    {
      roomCode: "room5",
      id: 5,
      label: "IL MATRIMONIO INASPETTATO",
      link: "/rooms/5",
      src: matri,
    },
  ];
  const { id } = useParams(); // Ottiene il parametro id dall'URL
  const room = roomsData.find((r) => r.id === parseInt(id));
  if (!room) {
    return (
      <Box>
        <Typography variant="h4">Camera non trovata</Typography>
      </Box>
    );
  }

  return (
    <Stack alignItems={"center"} width={"100%"} sx={{ overflowX: "hidden" }}>
      <div
        style={{
          top: 0,
          zIndex: 999999990,
          width: "100%",
          position: "fixed",
          pointerEvents: "none",
          height: "100vh",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        <Box padding={"0 30px 20px 0"}>
          {" "}
          <SocialIcons isHome />
        </Box>
        {isMobile && (
          <DividerContainer height={"100%"} zIndex={1} paddingTop="0px" />
        )}
      </div>
      {/* FIXED position */}
      {isMobile ? (
        <BrochureImage
          src={room.src}
          text={room.label}
          width={"100vw"}
          isHeading={isMobile ? true : false}
          fontSize={isTablet ? "80px" : "35px"}
        />
      ) : (
        <ParallaxBanner
          layers={[
            { image: room.src, amount: 0.2 }, // Background con scrolling lento
          ]}
          style={{
            height: "100vh",
            position: "fixed", // Mantiene il banner fisso
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 1,
          }}
        >
          <Box
            width={"100%"}
            height={"100vh"}
            display={"flex"}
            justifyContent={"center"}
            sx={{
              backgroundImage: `url(${room.src})`,
              backgroundSize: "cover",
              backgroundPosition: "bottom",
              backgroundRepeat: "no-repeat",
              height: "100vh",
              width: "100%",
              position: "relative",
            }}
          >
            {" "}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(87, 87, 87, 0.236)", // Layer scuro semi-trasparente
                zIndex: 1, // Assicura che il layer sia sopra l'immagine ma sotto il testo
              }}
            />
            <Typography
              variant={"h2"}
              sx={{
                zIndex: 2,
                color: "white",
                fontSize: "5vw",
                textAlign: "center",
                alignSelf: "center",
                letterSpacing: "3px",
              }}
            >
              {room.label}
            </Typography>
          </Box>
        </ParallaxBanner>
      )}
      <Box sx={{ height: "100vh", display: isMobile ? "none" : "block" }} />
      <div
        style={{
          zIndex: 3,
          backgroundColor: "white",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          // padding: "0 20px",
          // marginTop: "20px",
        }}
      >
        <CarouselInfo isOpen={true} roomName={room.roomCode} id={room.id} />
        <Box width={"100%"} alignItems={"center"} justifyContent={"center"}>
          {" "}
          <CarouselRooms index={room.roomCode} />
        </Box>
        <div
          style={{
            marginTop: isMobile ? "40px" : "80px",
            width: "100%",
          }}
        ></div>{" "}
        <Typography
          sx={{
            color: isMobile ? "#000" : "#1f5f91",
            fontFamily: "ivymode",
            letterSpacing: isMobile ? undefined : "2px",
          }}
          variant={isMobile ? "h3" : "subtitle2"}
          lineHeight={isMobile ? "22px" : "28px"}
          fontSize={isMobile ? "20px" : "30px"}
          fontWeight={"300"}
          textAlign="center"
        >
          <i>{t("servizicamera")}</i>
        </Typography>
        <RoomDetails
          selectedIndex={room.id}
          isCenter={true}
          room={room.roomCode}
        />
        <SectionTwoStableMob isPageSingle />
        {isMobile ? null : (
          <>
            {" "}
            <Divider
              sx={{
                my: 3,
              }}
              width={"30%"}
              margin={"0 auto"}
            />{" "}
            <RoomTab />
          </>
        )}
        <Divider
          sx={{
            my: 3,
          }}
          width={"30%"}
          margin={"0 auto"}
        />
        {isMobile ? (
          <></>
        ) : (
          <>
            {" "}
            <Box width={"30vw"}>
              {" "}
              <CustomTypography children={<FollowBox />} />
            </Box>
            <FooterGallery />
          </>
        )}
      </div>
      <Footer />
    </Stack>
  );
};

export default RoomSingle;
